module.exports = __webpack_public_path__ + "static/img/5.3f0426a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/5.png
// module id = fNjO
// module chunks = 0